// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"ErrorPage_errorPage__3jy0f","container":"ErrorPage_container__29-Mi","searchBlock":"ErrorPage_searchBlock__hXNWL","errorBlock":"ErrorPage_errorBlock__1Nm3z"};